import UserMetricsPage from "features/accountsAdmin/UserMetricsPage";
import React from "react";

function ManageAccountsPage() {
    return <UserMetricsPage isAdminManagementPage />;
}

export default ManageAccountsPage;
